import { CopyOutlined } from '@ant-design/icons';
import { saveAs } from 'file-saver';
import React, { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { StreamQrPayServiceClient } from './lib/service_stream_qr_pay_grpc_web_pb';
import { GetQRpayReq } from './lib/service_stream_qr_pay_pb';

import {
  Alert,
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Input,
  Modal,
  notification,
  Row,
  Typography,
} from 'antd';
import Countdown from 'react-countdown';
import ACB from '../../assets/images/logo-bank/ACB.png';
import MB from '../../assets/images/logo-bank/MB.png';
import { banks } from './lib/vietnam-bank';
import { useHistory, useLocation } from 'react-router-dom';
import { promotionClient } from 'pkg/request/clients';
import { getCookie, setCookie } from 'pkg/cookie/helpers';
import axios from 'axios';
import { t } from 'i18n';
import {
  AUTHOR_USER,
  KEY_ACCESS_TOKEN,
  KEY_REFRESH_TOKEN,
} from 'pkg/cookie/constants';
import { getCurrentLanguage } from 'pkg/localization/helpers';
// Add a console.log to check if the 'GetQRpayReq' is exported from the module
console.log(GetQRpayReq);
const { Title, Text } = Typography;
const SIGNAL_FAIL = 'fail';
const SIGNAL_QR_CODE = 'qrcode';
const SIGNAL_GET_TRIAL = 'gettrial';
const SIGNAL_WAIT = 'wait';
const SIGNAL_END = 'end';

const CKPayStatus_Success = 'ck.success';
const CKPayStatus_Over = 'ck.over.fund';
const CKPayStatus_Insufficient = 'ck.insufficient.fund';

var url = `${process.env.REACT_APP_PROMOTION_DOMAIN}`;
var client = new StreamQrPayServiceClient(url, null, null);
var stream: any = null;
var enableTimeout = true;

function SafePayment() {
  const history = useHistory();
  const location = useLocation();
  // const [Clock, setClock] = useState('00:00:00');
  // const [Signal, setSignal] = useState('init');
  // const [Message, setMessage] = useState('wait response');

  // const [Bank, setBank] = useState('');
  const [BankBin, setBankBin] = useState('');
  const [AccNumber, setAccNumber] = useState('0');
  const [AccName, setAccName] = useState('');
  const [Amount, setAmount] = useState('0');
  const [Purpose, setPurpose] = useState('pay to safeweb');
  const [ImageSrc, setImageSrc] = useState('');

  const [messageBox, setMessageBox] = useState<any>({});

  // const [Code, setCode] = useState('');
  // const [Status, setStatus] = useState('');
  // const [Data, setData] = useState('');

  interface LastOrder {
    admin_id: string;
    admin_title: string;
    admin_name: string;
    admin_phone: string;
    admin_country: string;
    order_total: number;
    order_info: string;
    product_name: string;
    product_code: string;
    product_price: number;
    product_unit: string;
    product_discount: number;
    product_tax: number;
    product_quantity: number;
    product_description: string;
    coupon: string;
  }

  const getStats = () => {
    const lastOrder = location.state as LastOrder;

    // calling http/1
    var request = new GetQRpayReq();

    request.setAdminId(lastOrder.admin_id);
    request.setAdminTitle(lastOrder.admin_title);
    request.setAdminName(lastOrder.admin_name);
    request.setAdminPhone(lastOrder.admin_phone);
    request.setAdminCountry(lastOrder.admin_country);
    request.setOrderTotal(lastOrder.order_total);
    request.setOrderInfo(lastOrder.order_info);
    request.setProductName(lastOrder.product_name);
    request.setProductCode(lastOrder.product_code);
    request.setProductPrice(lastOrder.product_price);
    request.setProductUnit(lastOrder.product_unit);
    request.setProductDiscount(lastOrder.product_discount);
    request.setProductTax(lastOrder.product_tax);
    request.setProductQuantity(lastOrder.product_quantity);
    request.setProductDescription(lastOrder.product_description);
    request.setCoupon(lastOrder.coupon);

    stream = client.getQRpay(request, {});

    console.log('request');
    console.log(request);

    console.log('stream');
    enableTimeout = true;
    var chuyenKhoan = '';

    // Start listening on the data event, this is the event that is used to notify that new data arrives
    stream.on('data', function (response: any) {
      var logTime = new Date();
      var timeString =
        logTime.getHours() +
        ':' +
        logTime.getMinutes() +
        ':' +
        logTime.getSeconds();
      console.log(timeString);
      console.log(response);

      // Convert Response to Object
      var cmdRes = response.toObject();

      if (cmdRes.signal === SIGNAL_FAIL) {
        console.log(
          'Thông báo lỗi hệ thống cho user để họ tự tạo lại page này.'
        );
        setMessageBox({
          title: 'Có lỗi thao tác',
          content: 'Bạn có muốn thực hiện lại không?',
          isOpen: true,
        });
      } else if (cmdRes.signal === SIGNAL_QR_CODE) {
        console.log('Đặt timeout cho page này 10 phút. Sau 10 phút hủy mã QR.');

        // refer: https://www.vietqr.io/en/intro
        // https://img.vietqr.io/image/<BANK_ID>-<ACCOUNT_NO>-<TEMPLATE>.png
        // ?amount=<AMOUNT>&addInfo=<DESCRIPTION>&accountName=<ACCOUNT_NAME>
        let imgSrc = 'https://img.vietqr.io/image/';
        imgSrc += cmdRes.bankInfo.bankKey;
        imgSrc += '-' + cmdRes.accountNumber;
        imgSrc += '-compact.png';
        imgSrc += '?amount=' + cmdRes.payAmount;
        imgSrc += '&addInfo=' + cmdRes.payPurpose;
        imgSrc += '&accountName=' + cmdRes.accountName;

        let encodedUrl = encodeURI(imgSrc);
        console.log(encodedUrl);
        setImageSrc(encodedUrl);
      } else if (cmdRes.signal === SIGNAL_GET_TRIAL) {
        console.log('Page hiển thị ảnh loading.');
        setImageSrc('https://safeweb.app/static/img/icon.png');
      } else if (cmdRes.signal === SIGNAL_WAIT) {
        console.log(
          'Page không làm gì. Hiển thị đồng hồ đếm ngược 10 phút về 0 để user hiểu timeout.'
        );
        if (enableTimeout) {
          var tenMinutes = 10 * 60 * 1000;
          setTimeout(function () {
            cancelStream('Timeout to CANCEL stream');
            enableTimeout = false;
            // setMessageBox({
            //   title: 'Hết thời gian giao dịch',
            //   content: 'Bạn có muốn thực hiện lại giao dịch không?',
            //   isOpen: true,
            // });
          }, tenMinutes);
        }
      } else if (cmdRes.signal === SIGNAL_END) {
        console.log('Giao dịch chuyển khoản đã được thực hiện.');

        if (cmdRes.payStatus === CKPayStatus_Success) {
          console.log('Chuyển khoản thành công.');
          // cancelStream('client CANCEL stream');
          chuyenKhoan = 'Chuyển khoản thành công.';

          // history.push('/billing');
        } else if (cmdRes.payStatus === CKPayStatus_Over) {
          chuyenKhoan = 'Chuyển khoản thừa tiền.';
          // cancelStream('client CANCEL stream');

          // history.push('/billing');
        } else if (cmdRes.payStatus === CKPayStatus_Insufficient) {
          console.log('Chuyển khoản thiếu tiền.');
          chuyenKhoan = 'tt';
        } else {
          console.log('Liên hệ với SafeWeb để giải quyết sự cố.');
          chuyenKhoan = 'err';
          // chuyenKhoan = 'Liên hệ với SafeWeb để giải quyết sự cố.';
        }
        cancelStream('client CANCEL stream');
        // setMessageBox({
        //   title: 'Bạn đã thực hiện giao dịch',
        //   content: chuyenKhoan,
        //   isOpen: true,
        // });
        success(chuyenKhoan);
      }
      console.log('messageBox', messageBox);

      // Set our variable values
      // setClock(timeString);
      // setSignal(cmdRes.signal);
      // setMessage(cmdRes.message);

      // setBank(cmdRes.bankInfo.bankKey);
      setAccNumber(cmdRes.accountNumber);
      setAccName(cmdRes.accountName);
      setAmount(cmdRes.payAmount);
      setPurpose(cmdRes.payPurpose);
      setBankBin(cmdRes.bankInfo.bankBin);

      // setCode(cmdRes.payCode);
      // setStatus(cmdRes.payStatus);
      // setData(cmdRes.payData);
    });
    stream.on('end', function () {
      cancelStream('END stream by server');
    });

    stream.on('error', function (err: any) {
      cancelStream(
        `ERROR in stream: code = ${err.code}` + `, message = "${err.message}"`
      );
    });
  };
  const cancelStream = (message: any) => {
    if (stream != null) {
      stream.cancel();
      stream = null;
      console.log(message);
    }
  };

  // useEffect will make this trigger on component start
  useEffect(() => {
    getStats();
  }, []);

  const [bankName, setBankName] = useState<any>();
  const getAuthor = () => {
    return getCookie('author_user');
  };
  const getAdminId = () => {
    return getCookie('current_username');
  };
  const locale = getCurrentLanguage();
  useEffect(() => {
    const bankInfo = banks.find((bank) => bank.bankId === BankBin);
    if (bankInfo) {
      // const locale = localStorage.getItem('i18nextLng');
      setBankName({
        title: bankInfo.shortName,
        src: BankBin === '970422' ? MB : ACB,
        description: locale === 'en' ? bankInfo.en_name : bankInfo.vn_name,
      });
    }
  }, [BankBin, locale]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOk = () => {
    getStats();
    setIsModalOpen(false);
  };

  const handleOkMessageBox = () => {
    // setMessageBox({ ...messageBox, isOpen: false });
    cancelStream('User CANCEL stream');
    history.push('/billing');
  };

  const handleCancel = () => {
    // setIsModalOpen(false);
    cancelStream('User CANCEL stream');
    history.push('/billing');
  };
  const success = (content: string) => {
    if (content === 'tt') {
      Modal.error({
        content:
          'Chuyển khoản thiếu tiền. Giao dịch chưa thành công. Làm lại giao dịch.',
        onOk: handleOkMessageBox,
      });
    } else if (content === 'err') {
      Modal.error({
        content:
          'Liên hệ với SafeWeb để giải quyết sự cố. Giao dịch chưa thành công.',
        onOk: handleOkMessageBox,
      });
    } else {
      Modal.success({
        content,
        onOk: handleOkMessageBox,
      });
      const refreshToken = getCookie(KEY_REFRESH_TOKEN);
      promotionClient
        .post(`/user/get`, { user_name: getAdminId() })
        .then((res: any) => {
          if (res.data.success) {
            if (
              res.data.user.admin_role === 'standard' &&
              getAuthor() === 'free'
            ) {
              setCookie(AUTHOR_USER, 'standard');
              axios
                .get('/auth/refresh', {
                  headers: {
                    Authorization: `${refreshToken},${getAdminId()}`,
                    ContentType: 'application/json',
                  },
                  baseURL: `${process.env.REACT_APP_PROMOTION_DOMAIN}/api/v1`,
                })
                .then((res: any) => {
                  if (res.data) {
                    const { access_token, refresh_token } = res.data;
                    setCookie(KEY_ACCESS_TOKEN, access_token);
                    setCookie(KEY_REFRESH_TOKEN, refresh_token);
                  }
                });
            }
          } else {
            notification.error({
              message: t('Error'),
              description: res.data.message,
            });
          }
        })
        .catch((err: any) => {
          notification.error(err);
        });
    }
  };

  return (
    <div className="App">
      <Row justify="center" style={{ marginTop: '20px' }}>
        <Col lg={16} md={18} xs={24}>
          <Card>
            <Row gutter={16} align="middle">
              <Col
                md={{ span: 0 }}
                xs={{ span: 24 }}
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <Alert
                  message={
                    <Title level={4} style={{ color: '#52c41a' }}>
                      {t('safePay.autoConfirmTitle')}
                    </Title>
                  }
                  description={<Text>{t('safePay.autoConfirmContent')}</Text>}
                  type="success"
                  showIcon
                />
              </Col>
              <Col
                md={{ span: 10 }}
                xs={{ span: 24 }}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <Title level={5} style={{ textAlign: 'center' }}>
                  {t('safePay.titleQR')}
                </Title>
                <img
                  src={ImageSrc}
                  alt="QR Image"
                  width="300"
                  height="300"
                  style={{ textAlign: 'center' }}
                />
                {/* <Countdown date={Date.now() + 600000} renderer={renderer} />, */}
                <div style={{ padding: '5px 0px' }}>
                  <Countdown
                    key={isModalOpen ? 'modal' : 'countdown'}
                    date={Date.now() + 600000}
                    onComplete={() => setIsModalOpen(true)}
                    renderer={({ hours, minutes, seconds, completed }) => {
                      if (completed || isModalOpen) {
                        // Render a complete state
                        return '00:00';
                      } else {
                        // Render a countdown
                        return (
                          <span>{`${minutes > 9 ? minutes : '0' + minutes}: ${
                            seconds > 9 ? seconds : '0' + seconds
                          }`}</span>
                        );
                      }
                    }}
                  />
                </div>
                <Button onClick={() => saveAs(ImageSrc, `${Purpose}.jpg`)}>
                  {t('safePay.downloadQR')}
                </Button>
              </Col>
              <Col md={{ span: 14 }} xs={{ span: 24 }}>
                <Row>
                  <Col xs={{ span: 0 }} md={{ span: 24 }}>
                    <Alert
                      message={
                        <Title level={4} style={{ color: '#52c41a' }}>
                          {t('safePay.autoConfirmTitle')}
                        </Title>
                      }
                      description={
                        <Text>{t('safePay.autoConfirmContent')}</Text>
                      }
                      type="success"
                      showIcon
                    />
                  </Col>
                  <Col span={24}>
                    <Divider />
                    <Title level={4} style={{ textAlign: 'center' }}>
                      {t('safePay.infoBankTitle')}
                    </Title>
                    {bankName && (
                      <Row gutter={16}>
                        <Col
                          md={{ span: 4, offset: 3 }}
                          xs={{ span: 6, offset: 0 }}
                        >
                          <Avatar size={64} src={bankName.src} />
                        </Col>
                        <Col
                          md={{ span: 14 }}
                          xs={{ span: 18 }}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                          }}
                        >
                          <div>
                            {t('safePay.infoBank')}:{' '}
                            <Text strong>{bankName.title}</Text>
                          </div>
                          <Text strong>{bankName.description}</Text>
                        </Col>
                      </Row>
                    )}

                    <div style={{ marginTop: '10px' }}>
                      <Text strong>{t('safePay.infoBankHolder')}: </Text>
                      <Input
                        value={AccName}
                        readOnly
                        suffix={
                          <CopyToClipboard text={AccName}>
                            <CopyOutlined />
                          </CopyToClipboard>
                        }
                      />
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <Text strong>{t('safePay.infoBankNumber')}: </Text>
                      <Input
                        value={AccNumber}
                        readOnly
                        suffix={
                          <CopyToClipboard text={AccNumber}>
                            <CopyOutlined />
                          </CopyToClipboard>
                        }
                      />
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <Text strong>{t('safePay.infoBankAmount')}: </Text>
                      <Input
                        // value={`${Amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}đ`}
                        value={Amount}
                        readOnly
                        suffix={
                          <CopyToClipboard text={Amount}>
                            <CopyOutlined />
                          </CopyToClipboard>
                        }
                      />
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <Text strong>{t('safePay.infoBankContent')}: </Text>
                      <Input
                        value={Purpose}
                        readOnly
                        suffix={
                          <CopyToClipboard text={Purpose}>
                            <CopyOutlined />
                          </CopyToClipboard>
                        }
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Modal
        title="Phiên giao dịch hết giờ!"
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Tiếp tục"
        cancelText="Hủy bỏ"
      >
        <p>Bạn có muốn tiếp tục không?</p>
      </Modal>
      {/* <Modal.success
        title={`messageBox.title`}
        visible={messageBox.isOpen}
        onOk={handleOkMessageBox}
        onCancel={handleCancel}
        okText="Ok"
        cancelText="Hủy bỏ"
      >
        <p>{messageBox.content}</p>
      </Modal.success> */}
    </div>
  );
}

export default SafePayment;
